// custom-variant-labels.js - robuste Version für Impact
// - Liest window.PRODUCT_VARIANT_LABEL_MAP (in main-product.liquid gesetzt)
// - Ersetzt sichtbare Texte der Variant-Buttons (Block, Swatch, Dropdown)
// - Reagiert auf dynamische Updates des Themes via Events und MutationObserver

(function() {
  const DEBUG = false; // bei Bedarf auf true setzen

  function qsa(root, sel) { return root.querySelectorAll(sel); }
  function log(...args) { if (DEBUG) console.log('[variant-labels]', ...args); }

  // Falls jemand das Metafield als String gepflegt hat: String -> JSON parsen
    if (typeof window.PRODUCT_VARIANT_LABEL_MAP === 'string') {
      try { window.PRODUCT_VARIANT_LABEL_MAP = JSON.parse(window.PRODUCT_VARIANT_LABEL_MAP); } catch(e) {}
    }

  // Kandidaten für anklickbare Werte - möglichst breit fassen
  function getCandidates(root) {
    const sels = [
      // Impact Standard
      '[data-product-variant-picker] .variant-picker__option-values label',
      '[data-product-variant-picker] .variant-picker__option-values .chip',
      '.variant-picker__option-values label',
      '.variant-picker__option-values .chip',

      // Radio + Label Muster
      'fieldset input[type="radio"] + label',

      // Dropdown/Popover-Buttons
      'button[data-option-value]',
      '[data-option-value]',

      // ARIA-Fallback
      '[role="radiogroup"] [role="radio"]'
    ];
    return qsa(root, sels.join(','));
  }

  // Rohwert ermitteln
  function labelFor(el) {
    // Manche Themes legen den Wert in data-Attributen ab
    const v =
      el.getAttribute?.('data-value') ||
      el.getAttribute?.('data-option-value') ||
      // innere Textknoten
      el.textContent?.trim() ||
      '';
    return v;
  }

  // Optionname ermitteln, um Schlüssel wie "Option:Wert" zu erlauben
  function optionNameFor(el) {
    const group = el.closest('fieldset, .product-form__input, .option-selector, .variant-picker__option');
    const legend = group?.querySelector('legend, .form__label, .variant-picker__option-name');
    return legend?.textContent?.trim() || null;
  }

  // Textnode finden - je nach Markup liegt der sichtbare Text in verschiedenen Spans
  function findTextNode(el) {
    return (
      el.querySelector?.('.swatch__value, .chip__text, .value, .button__text, .option-value__text, span') || el
    );
  }

  function applyMap(root=document) {
    const map = Object.assign({}, window.PRODUCT_VARIANT_LABEL_MAP || {});
    if (!map || !Object.keys(map).length) {
      log('keine Map gefunden - überspringe');
      return;
    }

    const items = getCandidates(root);
    if (!items.length) {
      log('keine Kandidaten im DOM gefunden');
      return;
    }

    items.forEach(el => {
      const raw = labelFor(el);
      if (!raw) return;

      const opt = optionNameFor(el);
      const keyWithOpt = opt ? `${opt}:${raw}` : null;

      const mapped = (keyWithOpt && map[keyWithOpt]) || map[raw];
      if (!mapped) return;

      el.setAttribute('aria-label', mapped);

      const node = findTextNode(el);
      if (!node) return;

      // HTML erlauben? Falls du HTML-Entities oder <svg> in der Map nutzt, innerHTML verwenden:
      // node.innerHTML = mapped.replace(/\n/g, '<br>');
      // Wenn du nur Text möchtest, textContent nutzen:
      node.textContent = mapped;
      node.style.whiteSpace = 'pre-line';
    });

    log('mapping angewendet auf', items.length, 'Elemente');
  }

  // Observer beobachtet Änderungen im Variant-Bereich und wendet Map erneut an
  function observe(root=document) {
    const pickerRoots = qsa(root, '[data-product-variant-picker], .variant-picker, fieldset.variant-picker__option');
    pickerRoots.forEach(picker => {
      // Einen Observer pro Picker
      const mo = new MutationObserver((mutations) => {
        // Wenn Kindelemente oder Texte geändert wurden, erneut anwenden
        for (const m of mutations) {
          if (m.type === 'childList' || m.type === 'characterData' || m.attributeName === 'aria-selected') {
            applyMap(picker);
            break;
          }
        }
      });
      mo.observe(picker, { childList: true, subtree: true, characterData: true, attributes: true });
    });
  }

  function init(root=document) {
    applyMap(root);
    observe(root);
  }

  // Start
  document.addEventListener('DOMContentLoaded', () => {
    init();

    // Impact/Shopify Events
    document.addEventListener('shopify:section:load', e => init(e.target));
    document.addEventListener('shopify:section:reorder', () => init());
    document.addEventListener('product:variant-change', () => init());

    // Fallback Re-Applys für späte Upgrades
    setTimeout(() => init(), 300);
    setTimeout(() => init(), 1000);
  });
})();
